// extracted by mini-css-extract-plugin
export default {"btnContainer":"ComplaintFormSelector_btnContainer__6LDow","btn":"ComplaintFormSelector_btn__wecx8"};